export default {
  strict: true,
  namespaced: true,
  state: {
    unroutedReservations: {
      list: [],
      checked: [],
      maxList: 0,
      currentPage: 1,
      perPage: 20,
      order: 'cb.pickupTime',
      orderAsc: 1,
      type: 'all',
      isLoading: false,
      search: ''
    }
  },
  mutations: {
    resetUnroutedReservationsList (state) { state.unroutedReservations.list = [] },
    addUnroutedReservation (state, value) { state.unroutedReservations.list.push(value) },
    setUnroutedReservationsChecked (state, value) { state.unroutedReservations.checked = value },
    removeUnroutedReservation (state) {
      if (state.unroutedReservations.checked.length && state.unroutedReservations.checked.length === 1) {
        let index = state.unroutedReservations.list.findIndex(x => x.id === state.unroutedReservations.checked[0])
        state.unroutedReservations.list.splice(index, 1)
        state.unroutedReservations.checked = []
      }
    },
    setUnroutedReservationsMaxList (state, value) { state.unroutedReservations.maxList = value },
    setUnroutedReservationsCurrentPage (state, value) { state.unroutedReservations.currentPage = value },
    setUnroutedReservationsPerPage (state, value) { state.unroutedReservations.perPage = value },
    setUnroutedReservationsOrder (state, value) { state.unroutedReservations.order = value },
    setUnroutedReservationsOrderAsc (state, value) { state.unroutedReservations.orderAsc = value },
    setUnroutedReservationsIsLoading (state, value) { state.unroutedReservations.isLoading = value },
    setUnroutedReservationsSearch (state, value) { state.unroutedReservations.search = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/laxit/unrouted-reservations.js